module.exports = __webpack_public_path__ + "img/hotel_rebate_logo.a31de3e3.png";